import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_ShCompanySearch = _resolveComponent("ShCompanySearch")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#tenants",
    max_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => _cache[3] || (_cache[3] = [
      _createTextVNode(" Edit Tenant ")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("label", null, "Name", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          ref: "i_name",
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.name) = $event)),
          "vread-from": "valid",
          "onUpdate:valid": $event => (($data.name_valid) = $event),
          minlength: 3,
          maxlength: 125,
          required: ""
        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
        _cache[5] || (_cache[5] = _createElementVNode("label", null, "Shared Company", -1 /* HOISTED */)),
        _createVNode(_component_ShCompanySearch, {
          modelValue: $data.shared_company_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.shared_company_id) = $event)),
          class: "shc-ddown",
          required: ""
        }, null, 8 /* PROPS */, ["modelValue"]),
        _cache[6] || (_cache[6] = _createElementVNode("label", null, "Domain", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          modelValue: $data.email_domain,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.email_domain) = $event)),
          "vread-from": "valid",
          "onUpdate:valid": $event => (($data.email_domain_valid) = $event),
          type: "domain",
          maxlength: 125
        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, { onClick: $options.close }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode(" Update ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}